module.exports = __webpack_public_path__ + "img/elementwidths_jasp.33fc2d3a.png";